














































































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { CustomField, CustomFieldData } from '@/models/Contact';
import { FileUpload } from '@/models/FileUpload';
import SingleSelect from '@/components/SingleSelect.vue';
import FilesUploader from './FilesUploader.vue';
import RadioGroup from './RadioGroup.vue';
import CheckboxGroup from './CheckboxGroup.vue';

import { websiteText } from '@/mixins/websiteTexts';

@Component({
    components: {
        SingleSelect,
        FilesUploader,
        RadioGroup,
        CheckboxGroup
    }
})

class DynamicForm extends Vue {
    @Prop({ required: true }) fields!: CustomField[];
    @Prop({ default: '' }) title!: string;
    @Prop({ default: '' }) text!: string;
    @Prop({ default: 'Submit' }) submitButtonText!: string;
    @Prop({ default: () => [] }) globalErrors!: string[];
    @Prop({ default: false }) isSubmitting!: boolean;
    @Prop({ default: false }) showGdprText!: boolean;
    @Prop({ default: false }) ctaColor!: boolean;
    @Prop({ default: true }) parentValidationPassed!: boolean;
    @Prop({ default: null }) wrapperClass!: string | null;
    @Prop({ default: false }) isExpandable!: boolean;

    formData: CustomFieldData[] = [];
    fieldErrors: { [key: number]: string } = {};

    created() {
        this.formData = this.fields.map(cf => ({
            title: cf.placeholder || '',
            value: '',
            files: [] as FileUpload[]
        }));

        this.fields.forEach((_, i) => {
            this.$set(this.fieldErrors, i, '');
        });
    }

    clearError(index: number) {
        this.fieldErrors[index] = '';
    }

    validateField(index: number): boolean {
        const field = this.fields[index];
        const fieldData = this.formData[index];
        const fieldValue = fieldData.value;
        const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

        this.fieldErrors[index] = '';

        if (field.mandatory && (!fieldValue || fieldValue.trim() === '') && (!fieldData.files || fieldData.files.length === 0)) {
            this.fieldErrors[index] = websiteText('site.contactform.missingmessage', [field.placeholder]);
            return false;
        }

        if (field.fieldType === 'EmailField' && fieldValue && !regEmail.test(fieldValue.toLowerCase())) {
            this.fieldErrors[index] = websiteText('site.contactform.emailincorrect');
            return false;
        }

        return true;
    }

    updateField(index: number, placeholder: string, val: any) {
        let files: FileUpload[] = [];
        let valueToStore: string = '';

        const looksLikeFileUpload = (obj: any) => {
            return obj && typeof obj === 'object' && (
                'fileSystemId' in obj || 'fileName' in obj || 'originalFileName' in obj || 'fileUrl' in obj
            );
        };

        if (Array.isArray(val) && val.length > 0 && looksLikeFileUpload(val[0])) {
            files = val as FileUpload[];
        } else if (looksLikeFileUpload(val)) {
            files = [val as FileUpload];
        } else {
            let incoming = val;
            if (incoming && typeof incoming === 'object' && 'target' in incoming) {
                incoming = (incoming.target && incoming.target.value) || '';
            }
            const selected = Array.isArray(incoming) ? incoming[0] : incoming;
            valueToStore = selected != null ? String(selected) : '';
        }

        this.formData[index] = {
            title: placeholder,
            value: valueToStore,
            files: files
        };

        if (this.fieldErrors[index]) {
            this.validateField(index);
        }    
    }

    validateForm(): boolean {
        let isValid = true;
        this.fields.forEach((_, index) => {
            if (!this.validateField(index)) isValid = false;
        });
        if (!this.parentValidationPassed) {
            isValid = false;
        }
        
        if (!isValid) {
            this.$nextTick(() => {
                const firstErrorEl = document.querySelector('.block-contact__field-error');
                
                if (firstErrorEl) {
                    firstErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    const parentContainer = firstErrorEl.parentElement;
                    if (parentContainer) {
                        const inputToFocus = parentContainer.querySelector('input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])') as HTMLElement;
                        
                        if (inputToFocus) {
                            inputToFocus.focus({ preventScroll: true });
                        }
                    }
                }
            });
        }
        return isValid;
    }

    submitForm() {
        this.$emit('submit-attempt');
        if (this.validateForm()) {
            this.$emit('submit', this.formData);
        }
    }
}

export default DynamicForm;
